import { Reveal } from "./Reveal";
import { Check, X } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const forWho = [
  "Você tem uma empresa rodando e quer parar de perder tempo com o que uma IA poderia fazer",
  "Você já usou ChatGPT ou Claude, mas nunca aplicou de verdade na operação",
  "Você quer entender onde a IA entra — sem precisar virar programador",
  "Você quer terminar cada sessão com algo funcionando, não com mais teoria pra processar",
];

const notForWho = [
  "Quem busca conteúdo superficial de curiosidade sobre IA",
  "Quem quer apenas tendência, sem aplicação prática",
  "Quem espera fórmula mágica e não topa colocar a mão na massa",
  "Quem não tem uma empresa rodando para aplicar os agentes",
  "Quem quer um pacote pronto e genérico, igual para todo mundo",
];

export function AudienceSection() {
  return (
    <section className="relative bg-charcoal py-12 md:py-16">
      <div className="container-narrow">
        <SectionHeading
          eyebrow="Para quem é"
          title="Este programa tem destinatário claro."
          subtitle="Como é construção ao vivo dentro da sua operação, o formato só funciona para quem tem o que colocar em cima da mesa."
        />

        <div className="mx-auto mt-16 grid max-w-5xl gap-6 md:grid-cols-2">
          <Reveal x={-20} duration={0.6}
            className="rounded-2xl border border-gold/30 bg-card/50 p-8"
          >
            <h3 className="mb-6 text-xl text-gold-soft">É para você se…</h3>
            <ul className="space-y-4">
              {forWho.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/20">
                    <Check className="h-3 w-3 text-gold" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed text-ivory/90">{item}</span>
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal x={20} duration={0.6}
            className="rounded-2xl border border-border/70 bg-card/30 p-8"
          >
            <h3 className="mb-6 text-xl text-slate-muted">Não é para você se…</h3>
            <ul className="space-y-4">
              {notForWho.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-muted">
                    <X className="h-3 w-3 text-slate-muted" strokeWidth={3} />
                  </span>
                  <span className="leading-relaxed text-slate-muted">{item}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
